/* unplugin-vue-components disabled */import script from "./HotelDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelDetails.vue?vue&type=script&setup=true&lang=js"

import "./HotelDetails.vue?vue&type=style&index=0&id=68fc899c&lang=scss"

const __exports__ = script;

export default __exports__